import React from 'react';
import PropTypes from 'prop-types';
import { TimeAgo } from 'components/TimeAgo';
import classNames from 'classnames';
import styles from './styles.module.scss';

/**
 * @param {object} props
 * @param {DateTime} props.date
 * @param {Boolean} props.isLive
 */
const ChatCardTimeStamp = ({
  date = null,
  isLive = false,
}) => (
  <div className={classNames(styles.chatCardTimestamp, {
    [styles.eventEnded]: !isLive,
  })}
  >
    {date && (
      <TimeAgo dateString={date.publishedAt} chatStyle />
    )}
  </div>
);

ChatCardTimeStamp.propTypes = {
  date: PropTypes.shape({
    createdAt: PropTypes.string,
    modifiedAt: PropTypes.string,
    publishedAt: PropTypes.string,
  }),
  isLive: PropTypes.bool,
};


export { ChatCardTimeStamp };
